import { render, staticRenderFns } from "./FieldStatus.vue?vue&type=template&id=3c5a1374&scoped=true&"
import script from "./FieldStatus.vue?vue&type=script&lang=js&"
export * from "./FieldStatus.vue?vue&type=script&lang=js&"
import style0 from "./FieldStatus.vue?vue&type=style&index=0&id=3c5a1374&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a1374",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5a1374')) {
      api.createRecord('3c5a1374', component.options)
    } else {
      api.reload('3c5a1374', component.options)
    }
    module.hot.accept("./FieldStatus.vue?vue&type=template&id=3c5a1374&scoped=true&", function () {
      api.rerender('3c5a1374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldStatus.vue"
export default component.exports